export default __webpack_public_path__ + "static/media/gym.674f281a.png";